import { Record } from "immutable";

const AdditionRecord = Record({
  id: null,
  denyFlg: false,
  qNo: "",
  // 追加
  title: "",
  text: "",
  // 関連
  choices: []
});

class Addition extends AdditionRecord {}

export default Addition;



// WEBPACK FOOTER //
// ./src/models/Addition.js